import React, { useState, useEffect } from 'react';
import URLManager from '../funcionalidadeNavbar/URLManager';
import { useNavigate } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

const CadastroOrdemProducao = () => {
  const [produtos, setProdutos] = useState([]);
  const [produtoId, setProdutoId] = useState(null);
  const [inputValue, setInputValue] = useState('');
  const [pedidosVenda, setPedidosVenda] = useState([]);
  const [pedidoVendaId, setPedidoVendaId] = useState(null);
  const [pedidoInputValue, setPedidoInputValue] = useState('');
  const [pedidoSelecionado, setPedidoSelecionado] = useState(null);
  const [gradeNumeracao] = useState(["19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40","41","42","43","44","45"]);
  const [gradeQuantidade, setGradeQuantidade] = useState({});
  const [gradePedidoOriginal, setGradePedidoOriginal] = useState({});
  const [dataInicio, setDataInicio] = useState('');
  const [dataFim, setDataFim] = useState('');
  const [mensagem, setMensagem] = useState('');
  const [faltasDetalhadas, setFaltasDetalhadas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [usarPedido, setUsarPedido] = useState(false);
  const [permitirEdicaoGrade, setPermitirEdicaoGrade] = useState(false);
  const [historicoPedido, setHistoricoPedido] = useState([]);
  const [mostrarHistorico, setMostrarHistorico] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Carregar produtos da API
    const fetchProdutos = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${URLManager.getBaseURL()}/produto/listar`, {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${sessionStorage.getItem('usuarioToken')}`
          }
        });
        if (!response.ok) throw new Error('Erro ao buscar produtos');
        const data = await response.json();
        console.log('Produtos retornados da API:', data);
        setProdutos(data);
      } catch (error) {
        setMensagem(error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchProdutos();
  }, []);

  useEffect(() => {
    // Carregar pedidos de venda
    const fetchPedidos = async () => {
      try {
        const response = await fetch(`${URLManager.getBaseURL()}/pedido-venda/lista-nao-finalizados`, {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${sessionStorage.getItem('usuarioToken')}`
          }
        });
        if (!response.ok) throw new Error('Erro ao buscar pedidos de venda');
        const data = await response.json();
        setPedidosVenda(data || []);
      } catch (error) {
        console.error('Erro ao carregar pedidos:', error);
      }
    };
    fetchPedidos();
  }, []);

  // Quando selecionar um pedido de venda, preencher automaticamente
  useEffect(() => {
    if (pedidoVendaId && pedidosVenda.length > 0) {
      const pedido = pedidosVenda.find(p => p.id === pedidoVendaId);
      if (pedido) {
        setPedidoSelecionado(pedido);
        
        // Definir produto do pedido
        const produtoIdDoPedido = pedido.idProduto?.idProduto || pedido.idProduto?.id;
        setProdutoId(produtoIdDoPedido);
        
        // Parsear grade do pedido
        let gradeObj = {};
        try {
          if (typeof pedido.gradeNumeracao === 'string') {
            gradeObj = JSON.parse(pedido.gradeNumeracao);
          } else if (typeof pedido.gradeNumeracao === 'object') {
            gradeObj = pedido.gradeNumeracao;
          }
        } catch (e) {
          console.error('Erro ao parsear grade:', e);
        }
        
        setGradePedidoOriginal(gradeObj);
        setGradeQuantidade(gradeObj);
        
        // Carregar histórico do pedido
        carregarHistoricoPedido(pedidoVendaId);
      }
    } else {
      setPedidoSelecionado(null);
      setGradePedidoOriginal({});
      setHistoricoPedido([]);
      setMostrarHistorico(false);
    }
  }, [pedidoVendaId, pedidosVenda]);

  const carregarHistoricoPedido = async (pedidoId) => {
    try {
      const response = await fetch(`${URLManager.getBaseURL()}/pedido-venda/historico/${pedidoId}`, {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: `Bearer ${sessionStorage.getItem('usuarioToken')}`
        }
      });
      if (response.ok) {
        const data = await response.json();
        setHistoricoPedido(data || []);
      }
    } catch (error) {
      console.error('Erro ao carregar histórico:', error);
    }
  };

  const calcularGradeRestante = () => {
    if (!pedidoSelecionado) return {};
    
    const gradeRestante = { ...gradePedidoOriginal };
    
    // Subtrair as quantidades já produzidas do histórico
    historicoPedido.forEach(hist => {
      if (hist.gradeProduzida) {
        Object.keys(hist.gradeProduzida).forEach(numero => {
          if (gradeRestante[numero]) {
            gradeRestante[numero] -= hist.gradeProduzida[numero] || 0;
            if (gradeRestante[numero] < 0) gradeRestante[numero] = 0;
          }
        });
      }
    });
    
    return gradeRestante;
  };

  const preencherGradeRestante = () => {
    const gradeRestante = calcularGradeRestante();
    setGradeQuantidade(gradeRestante);
  };

  const handleCadastro = async (e) => {
    e.preventDefault();
    if (produtoId === null || produtoId === undefined || produtoId === '' || isNaN(Number(produtoId))) {
      setMensagem('Selecione um produto válido!');
      return;
    }
    if (!dataInicio) {
      setMensagem('Preencha todos os campos obrigatórios.');
      return;
    }
    // Validação: pelo menos um tamanho com quantidade > 0
    const totalPares = Object.values(gradeQuantidade).reduce((acc, val) => acc + (parseInt(val) || 0), 0);
    if (totalPares === 0) {
      setMensagem('Informe a quantidade para pelo menos um tamanho da grade.');
      return;
    }
    setMensagem('');
    setFaltasDetalhadas([]);
    setLoading(true);
    try {
      const url = `${URLManager.getBaseURL()}/ordemProducao/cadastroOrdemProducao/${produtoId}`;
      const dto = {
        dataInicio,
        previsaoTermino: dataFim || null,
        gradeQuantidade: gradeQuantidade,
        quantidadePlanejada: totalPares,
        pedidoVendaId: usarPedido && pedidoVendaId ? pedidoVendaId : null
      };
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: `Bearer ${sessionStorage.getItem('usuarioToken')}`
        },
        body: JSON.stringify(dto)
      });
      const result = await response.text();
      if (response.ok) {
        setMensagem('Ordem de produção cadastrada com sucesso!');
        setGradeQuantidade({});
        setDataInicio('');
        setDataFim('');
        setProdutoId(null);
        setInputValue('');
        setPedidoVendaId(null);
        setPedidoInputValue('');
        setUsarPedido(false);
      } else {
        setMensagem(result || 'Erro ao cadastrar ordem de produção.');
        // Tentar parsear mensagens do backend sobre faltas e duplicatas
        if (result && result.includes('Estoque insuficiente')) {
          const detalhes = [];
          // Exemplo esperado: "... materiais: Nome (necessário: X, disponível: Y, falta: Z); Outro ..."
          const after = result.split('materiais:')[1] || '';
          const parts = after.split(';').map(s => s.trim()).filter(Boolean);
          parts.forEach(p => {
            const nome = p.split('(')[0]?.trim();
            const match = p.match(/necessário:\s*([0-9.,]+).*disponível:\s*([0-9.,]+).*falta:\s*([0-9.,]+)/i);
            if (match) {
              const necessario = parseFloat(match[1].replace(',', '.'));
              const disponivel = parseFloat(match[2].replace(',', '.'));
              const falta = parseFloat(match[3].replace(',', '.'));
              detalhes.push({ nome, necessario, disponivel, falta });
            } else if (nome) {
              detalhes.push({ nome });
            }
          });
          if (detalhes.length > 0) {
            setFaltasDetalhadas(detalhes);
          }
        }
      }
    } catch (error) {
      setMensagem('Erro de conexão com o servidor.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f4f6fa' }}>
      <div style={{ background: '#fff', borderRadius: 12, boxShadow: '0 4px 24px rgba(0,0,0,0.10)', padding: 32, minWidth: 350, maxWidth: 500 }}>
        <h2 style={{ textAlign: 'center', marginBottom: 24, color: '#2d3a4b' }}>Cadastro de Ordem de Produção</h2>
        <form onSubmit={handleCadastro}>
          <div style={{ marginBottom: 18 }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
              <input 
                type="checkbox" 
                checked={usarPedido} 
                onChange={(e) => {
                  setUsarPedido(e.target.checked);
                  if (!e.target.checked) {
                    setPedidoVendaId(null);
                    setPedidoInputValue('');
                    setProdutoId(null);
                    setGradeQuantidade({});
                  }
                }}
              />
              <span style={{ fontWeight: 500, color: '#2d3a4b' }}>Vincular a um Pedido de Venda</span>
            </label>
          </div>

          {usarPedido && (
            <div style={{ marginBottom: 18, background: '#e3f2fd', padding: 12, borderRadius: 6 }}>
              <label style={{ fontWeight: 500, color: '#2d3a4b' }}>Pedido de Venda:</label><br />
              <Autocomplete
                options={pedidosVenda}
                getOptionLabel={option => {
                  if (!option) return '';
                  const produzida = option.quantidadeProduzida || 0;
                  const total = option.quantidadeTotal || 0;
                  const restante = option.quantidadeRestante || total;
                  const status = option.statusProducao || 'PENDENTE';
                  return `#${option.id} - ${option.idCliente.nomeCliente} (${produzida}/${total} - ${restante} restantes) [${status}]`;
                }}
                value={pedidosVenda.find(p => p.id === pedidoVendaId) || null}
                onChange={(event, newValue) => {
                  setPedidoVendaId(newValue ? newValue.id : null);
                }}
                inputValue={pedidoInputValue}
                onInputChange={(event, newInputValue) => {
                  setPedidoInputValue(newInputValue);
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Selecione o pedido..." variant="outlined" size="small" />
                )}
                noOptionsText="Nenhum pedido encontrado"
                sx={{ width: '100%', marginTop: 1 }}
              />
              {pedidoSelecionado && (
                <div style={{ marginTop: 12 }}>
                  <div style={{ fontSize: 13, color: '#1565c0', marginBottom: 8 }}>
                    📊 <strong>Status do Pedido:</strong>
                    <div style={{ marginLeft: 20, marginTop: 4 }}>
                      • Total: {pedidoSelecionado.quantidadeTotal || 0} pares<br/>
                      • Produzido: {pedidoSelecionado.quantidadeProduzida || 0} pares<br/>
                      • Restante: {pedidoSelecionado.quantidadeRestante || pedidoSelecionado.quantidadeTotal || 0} pares<br/>
                      • Status: <strong>{pedidoSelecionado.statusProducao || 'PENDENTE'}</strong>
                    </div>
                  </div>
                  
                  <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
                    <button
                      type="button"
                      onClick={() => setMostrarHistorico(!mostrarHistorico)}
                      style={{
                        padding: '6px 12px',
                        background: '#ff9800',
                        color: '#fff',
                        border: 'none',
                        borderRadius: 4,
                        cursor: 'pointer',
                        fontSize: 12
                      }}
                    >
                      {mostrarHistorico ? 'Ocultar' : 'Ver'} Histórico ({historicoPedido.length})
                    </button>
                    
                    <button
                      type="button"
                      onClick={preencherGradeRestante}
                      style={{
                        padding: '6px 12px',
                        background: '#4caf50',
                        color: '#fff',
                        border: 'none',
                        borderRadius: 4,
                        cursor: 'pointer',
                        fontSize: 12
                      }}
                    >
                      Preencher Grade Restante
                    </button>
                    
                    <label style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 12 }}>
                      <input 
                        type="checkbox" 
                        checked={permitirEdicaoGrade}
                        onChange={(e) => setPermitirEdicaoGrade(e.target.checked)}
                      />
                      Editar Grade Manualmente
                    </label>
                  </div>
                  
                  {mostrarHistorico && historicoPedido.length > 0 && (
                    <div style={{ marginTop: 12, background: '#fff', padding: 10, borderRadius: 4, maxHeight: 200, overflowY: 'auto' }}>
                      <strong style={{ fontSize: 13 }}>Histórico de Produção:</strong>
                      {historicoPedido.map((hist, idx) => (
                        <div key={hist.id} style={{ 
                          fontSize: 12, 
                          padding: '6px 0', 
                          borderBottom: idx < historicoPedido.length - 1 ? '1px solid #eee' : 'none' 
                        }}>
                          <div><strong>OP #{hist.mapaOrdemProducao}</strong> - {hist.quantidadeProduzida} pares</div>
                          <div style={{ color: '#666' }}>
                            {new Date(hist.dataProducao).toLocaleString('pt-BR')}
                          </div>
                          <div style={{ color: '#666', fontSize: 11 }}>
                            Grade: {hist.gradeProduzida ? Object.entries(hist.gradeProduzida).map(([num, qtd]) => `${num}:${qtd}`).join(', ') : 'N/A'}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </div>
          )}

          <div style={{ marginBottom: 18 }}>
            <label style={{ fontWeight: 500, color: '#2d3a4b' }}>Produto:</label><br />
            <Autocomplete
              options={produtos}
              getOptionLabel={option => {
                if (!option) return '';
                if (typeof option === 'string') return option;
                // Exibe nomeModelo | Marca: marca | Ref: referencia | Cor: cor
                let label = '';
                if (option.nomeModelo) label += option.nomeModelo;
                if (option.marca) label += ` | Marca: ${option.marca}`;
                if (option.referencia) label += ` | Ref: ${option.referencia}`;
                if (option.cor) label += ` | Cor: ${option.cor}`;
                return label.trim() || JSON.stringify(option);
              }}
              filterOptions={(options, state) =>
                options.filter(option => {
                  const search = state.inputValue.toLowerCase();
                  const nomeModelo = (option.nomeModelo || '').toLowerCase();
                  const marca = (option.marca || '').toLowerCase();
                  const referencia = (option.referencia || '').toLowerCase();
                  return (
                    nomeModelo.includes(search) ||
                    marca.includes(search) ||
                    referencia.includes(search)
                  );
                })
              }
              value={produtos.find(p => String(p.idProduto) === String(produtoId)) || null}
              onChange={(event, newValue) => {
                setProdutoId(newValue ? newValue.idProduto : null);
              }}
              inputValue={inputValue}
              onInputChange={(event, newInputValue) => {
                setInputValue(newInputValue);
              }}
              disabled={usarPedido && pedidoVendaId !== null}
              renderInput={(params) => (
                <TextField {...params} label="Digite para buscar..." variant="outlined" size="small" autoFocus />
              )}
              isOptionEqualToValue={(option, value) => String(option.idProduto) === String(value.idProduto)}
              noOptionsText="Nenhum produto encontrado"
              sx={{ width: '100%', marginTop: 1 }}
              autoHighlight
              openOnFocus
              clearOnBlur={false}
            />
          </div>
          <div style={{ marginBottom: 18 }}>
            <label style={{ fontWeight: 500, color: '#2d3a4b' }}>
              Grade de Numeração e Quantidades:
              {usarPedido && pedidoVendaId && (
                <span style={{ fontSize: 12, color: permitirEdicaoGrade ? '#f57c00' : '#1565c0', marginLeft: 8 }}>
                  {permitirEdicaoGrade ? '(edição manual ativada - você pode produzir PARCIALMENTE)' : '(grade do pedido)'}
                </span>
              )}
            </label>
            {usarPedido && pedidoSelecionado && (
              <div style={{ fontSize: 12, color: '#d32f2f', marginTop: 4, marginBottom: 8 }}>
                💡 <strong>Dica:</strong> Você pode produzir apenas parte do pedido agora e criar outra ordem depois para o restante!
              </div>
            )}
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 8 }}>
              {gradeNumeracao.map((tamanho) => {
                const gradeRestante = calcularGradeRestante();
                const qtdRestante = gradeRestante[tamanho] || 0;
                const qtdOriginal = gradePedidoOriginal[tamanho] || 0;
                const temRestante = qtdRestante > 0;
                
                return (
                  <div key={tamanho} style={{ 
                    display: 'flex', 
                    flexDirection: 'column', 
                    alignItems: 'center',
                    opacity: usarPedido && !temRestante ? 0.4 : 1
                  }}>
                    <span style={{ fontSize: 13, color: '#2d3a4b', marginBottom: 2 }}>
                      {tamanho}
                      {usarPedido && qtdOriginal > 0 && (
                        <span style={{ fontSize: 10, color: qtdRestante > 0 ? '#f57c00' : '#4caf50' }}>
                          {qtdRestante > 0 ? ` (${qtdRestante})` : ' ✓'}
                        </span>
                      )}
                    </span>
                    <input
                      type="number"
                      min="0"
                      max={usarPedido && !permitirEdicaoGrade ? qtdRestante : undefined}
                      value={gradeQuantidade[tamanho] || ''}
                      onChange={e => {
                        const val = e.target.value;
                        setGradeQuantidade(prev => ({ ...prev, [tamanho]: val }));
                      }}
                      style={{ 
                        width: 50, 
                        padding: 4, 
                        borderRadius: 6, 
                        border: `1px solid ${temRestante && usarPedido ? '#ff9800' : '#cfd8dc'}`, 
                        textAlign: 'center',
                        backgroundColor: (usarPedido && pedidoVendaId && !permitirEdicaoGrade) ? '#f5f5f5' : 'white'
                      }}
                      placeholder="0"
                      disabled={usarPedido && pedidoVendaId !== null && !permitirEdicaoGrade}
                    />
                  </div>
                );
              })}
            </div>
            <div style={{ marginTop: 8, fontWeight: 500, color: '#1976d2' }}>
              Total de pares desta ordem: {Object.values(gradeQuantidade).reduce((acc, val) => acc + (parseInt(val) || 0), 0)}
              {usarPedido && pedidoSelecionado && (
                <span style={{ marginLeft: 10, color: '#f57c00', fontSize: 13 }}>
                  (Restante total do pedido: {pedidoSelecionado.quantidadeRestante || 0})
                </span>
              )}
            </div>
          </div>
          <div style={{ marginBottom: 18 }}>
            <label style={{ fontWeight: 500, color: '#2d3a4b' }}>Data de Início:</label><br />
            <input
              type="date"
              value={dataInicio}
              onChange={e => setDataInicio(e.target.value)}
              style={{ width: '100%', padding: 8, borderRadius: 6, border: '1px solid #cfd8dc', marginTop: 4 }}
              required
            />
          </div>
          <div style={{ marginBottom: 18 }}>
            <label style={{ fontWeight: 500, color: '#2d3a4b' }}>Data de Fim (opcional):</label><br />
            <input
              type="date"
              value={dataFim}
              onChange={e => setDataFim(e.target.value)}
              style={{ width: '100%', padding: 8, borderRadius: 6, border: '1px solid #cfd8dc', marginTop: 4 }}
            />
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 18 }}>
            <button
              type="submit"
              disabled={loading}
              style={{
                width: '100%',
                background: '#1976d2',
                color: '#fff',
                border: 'none',
                borderRadius: 6,
                padding: '10px 0',
                fontWeight: 600,
                cursor: loading ? 'not-allowed' : 'pointer',
                marginRight: 0
              }}
            >
              {loading ? 'Cadastrando...' : 'Cadastrar Ordem de Produção'}
            </button>
          </div>
        </form>
        <button
          onClick={() => navigate(-1)}
          style={{
            width: '100%',
            background: '#607d8b',
            color: '#fff',
            border: 'none',
            borderRadius: 6,
            padding: '10px 0',
            fontWeight: 600,
            cursor: 'pointer',
            marginBottom: 10
          }}
        >
          Voltar
        </button>
        {mensagem && (
          <div style={{
            marginTop: 10,
            color: mensagem.includes('sucesso') ? '#388e3c' : '#d32f2f',
            background: mensagem.includes('sucesso') ? '#e8f5e9' : '#ffebee',
            borderRadius: 6,
            padding: 10,
            textAlign: 'left',
            fontWeight: 500
          }}>
            <div style={{ marginBottom: 8, textAlign: 'center' }}>{mensagem}</div>
            {faltasDetalhadas.length > 0 && (
              <div style={{ fontSize: 13, color: '#c62828' }}>
                <div style={{ marginBottom: 6 }}>Materiais com falta:</div>
                <ul style={{ margin: 0, paddingLeft: 18 }}>
                  {faltasDetalhadas.map((f, idx) => (
                    <li key={idx}>
                      <strong>{f.nome}</strong>
                      {typeof f.necessario === 'number' ? (
                        <span> — necessário: {f.necessario}, disponível: {f.disponivel}, falta: <strong>{f.falta}</strong></span>
                      ) : null}
                    </li>
                  ))}
                </ul>
                <div style={{ marginTop: 10, display: 'flex', gap: 8 }}>
                  <button
                    type="button"
                    onClick={() => {
                      try {
                        localStorage.setItem('formularioAtivo', 'compras');
                        window.dispatchEvent(new CustomEvent('setDashboardTab', { detail: { tab: 'compras' } }));
                      } catch (e) {}
                    }}
                    style={{
                      padding: '8px 12px',
                      background: '#1976d2',
                      color: '#fff',
                      border: 'none',
                      borderRadius: 6,
                      cursor: 'pointer',
                      fontSize: 12,
                      fontWeight: 600
                    }}
                  >
                    Abrir Compras
                  </button>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default CadastroOrdemProducao;
